export const parseInputNumber = (value: any) =>
  typeof value === 'undefined' || (!value && value !== 0) ? value : Number(value);
